<template>
  <div>
    <v-dialog v-model="dialog" width="800px">
      <v-card>
        <v-card-title>
          <span class="headline">
            {{
              $t(
                type == 1
                  ? "Wave.errorMaterialDetailFields.edit_stock_out_num"
                  : type == 2
                  ? "Wave.errorMaterialDetailFields.stock_out_part"
                  : "CRUD.info",
                [""]
              )
            }}
          </span>
          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" @click="dialog = false"
                >fa-times
              </v-icon>
            </template>
            <span>
              {{ $t("CRUD.backToList", [$t("Wave.waveGenerate")]) }}
            </span>
          </v-tooltip>
        </v-card-title>
        <v-card-text style="max-height: 580px; overflow-y: scroll !important">
          <v-container
            v-for="(materialDetails, key) in errorMaterialDetails"
            :key="key"
          >
            <v-row align="center">
              <v-col cols="2" class="font-weight-bold text-right">
                {{
                  $t("Wave.errorMaterialDetailFields.material") +
                  $t("Global.colon")
                }}
              </v-col>
              <v-col cols="2" class="text-left">
                {{ materialDetails.material_name }}
              </v-col>
              <v-col cols="2" class="font-weight-bold text-right accent--text">
                {{
                  $t("Wave.errorMaterialDetailFields.stock_out_real_count") +
                  $t("Global.colon")
                }}
              </v-col>
              <v-col cols="2" class="text-left accent--text">
                {{ materialDetails.stock_out_real_count | formatTwoDot
                }}{{ materialDetails.default_unit }}
              </v-col>
              <v-col cols="2" class="font-weight-bold text-right accent--text">
                {{
                  $t("Wave.errorMaterialDetailFields.position_num_count") +
                  $t("Global.colon")
                }}
              </v-col>
              <v-col cols="2" class="text-left accent--text">
                {{ materialDetails.position_num_total | formatTwoDot
                }}{{ materialDetails.default_unit }}
              </v-col>
            </v-row>

            <v-data-table
              id="materials_info_table"
              :headers="detailsHeaders"
              :items="materialDetails.out_details"
              disable-sort
              disable-pagination
              hide-default-footer
            >
              <template v-slot:item.material_name="{ item }">
                <span>
                  {{
                    $t(settings
                        ? settings.material_name_display_type == 1
                            ? "Material.materialName"
                            : settings.material_name_display_type == 4
                                ? "Material.nameWithCode"
                            : "Material.materialNameWithCode"
                        : "Material.materialName", [item.material_code, item.material_name])
                  }}
                </span>
                <br />
                <span class="caption secondary--text">
                  {{ $t("Material.Fields.standard") }}{{ $t("Global.colon")}}
                  <span v-if="item.standard_name && item.standard_name.length > 12" :title="item.standard_name" style="cursor: pointer">
                    {{ item.standard_name.slice(0, 12) + "......" }}
                  </span>
                  <span v-else>
                    {{ item.standard_name }}
                  </span>
                </span>
              </template>
              <template v-slot:item.stock_order_code="{ item }">
                <span class="text-no-wrap caption font-weight-bold">
                  {{ item.stock_order_code }}
                </span>
                <br />
                <span
                  class="text-no-wrap caption secondary--text"
                  :class="
                    $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
                  "
                >
                  {{ item.shop_code }}
                </span>
              </template>
              <template v-slot:item.order_num="{ item }">
                {{ item.order_num | formatTwoDot }}
              </template>
              <template v-slot:item.confirm_num="{ item }">
                <NumberInput
                  v-model="item.confirm_num"
                  dense
                />
              </template>
            </v-data-table>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" outlined @click="dialog = false">{{
            $t("$vuetify.close")
          }}</v-btn>
          <v-btn color="accent" @click="submitErrMaterialDetails()">{{
            $t("$vuetify.confirm")
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import NumberInput from "@/components/plugins/NumberInput";
import Waves from "@/api/waves";

export default {
  name: "errorMaterialDetailsDialog",

  props: {
    value: Boolean,
    errorMaterialDetails: Array,
    type: Number,
  },

  components: {
    NumberInput,
  },

  computed: {
    detailsHeaders() {
      var headers = [
        {
          text: i18n.t("Wave.errorMaterialDetailFields.material"),
          align: "center",
          value: "material_name",
        },
        {
          text:
            i18n.t("Wave.errorMaterialDetailFields.stock_out_code") +
            "/" +
            i18n.t("Wave.errorMaterialDetailFields.shop_name", [
              this.$consts.shopName(),
            ]),
          align: "center",
          value: "stock_order_code",
        },
        {
          text: i18n.t("Wave.errorMaterialDetailFields.unit"),
          align: "center",
          value: "unit",
        },
        {
          text: i18n.t("Wave.errorMaterialDetailFields.stock_out_num"),
          align: "center",
          value: "order_num",
        },
        {
          text: i18n.t("Wave.errorMaterialDetailFields.stock_out_real_quatity"),
          align: "center",
          value: "confirm_num",
        },
      ];

      return headers;
    },
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["settings"]),
  },

  data: () => ({
    dialog: false,
    recheck: false,
    refreshList: false,
  }),

  watch: {
    value: {
      immediate: true,
      handler() {
        this.dialog = this.value;
      },
    },
    dialog: {
      handler() {
        this.$emit("input", this.dialog);
      },
    },
    errorMaterialDetails: {
      handler() {
        if (this.errorMaterialDetails.length) {
          this.recheck = false;
          this.refreshList = false;
        }
      },
    },
    recheck: {
      handler() {
        this.$emit("recheckGenerate", this.recheck);
      },
    },
    refreshList: {
      handler() {
        this.$emit("refreshList", this.refreshList);
      },
    },
  },

  methods: {
    //提交部分出库或修改出库数量
    submitErrMaterialDetails() {
      var outDetails = [];
      //整理提交数据
      this.errorMaterialDetails.forEach((materialDetails) => {
        materialDetails.out_details.forEach((detail) => {
          outDetails.push({
            detail_id: detail.id,
            confirm_num: detail.confirm_num,
          });
        });
      });
      Waves.saveErrMaterialOutDetail({
        type: this.type,
        out_details: outDetails,
      }).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.dialog = false;
            this.recheck = true;

            //部分出库
            if (this.type == 2) {
              this.$emit("removeOuts", response.data.remove_outs);
              this.$emit("addOuts", response.data.add_outs);
              if (
                response.data.remove_outs.length ||
                response.data.add_outs.length
              ) {
                this.refreshList = true;
              }
            }
          }
        }.bind(this)
      );
    },
  },
};
</script>